import { useUserStore } from '@/js/user';
import {createRouter, createWebHistory} from 'vue-router'
import LoginPage from '../pages/LoginPage.vue'
import DashboardPage from '../pages/DashboardPage.vue'
import ProfilePage from '../pages/ProfilePage.vue'
import PasswordResetPage from '../pages/PasswordResetPage.vue'

export const router = createRouter({
    history: createWebHistory(),
    routes: [
        { name: 'login', path: '/login', component: LoginPage, meta: {title: 'Login '}},
        { name: 'dashboard', path: '/', component: DashboardPage, meta: {title: 'Dashboard'}},
        { name: 'profile', path: '/profile', component: ProfilePage, meta: {title: 'Profil'}}, 
        { name: 'password-reset', path: '/reset-password', component: PasswordResetPage, meta: {title: 'Reset password'}}
    ]
});

router.beforeEach(async (to) => {
    const userStore = useUserStore()
    let authenticated = await userStore.isAuthenticated();
      if (
          // ❗️ Avoid an infinite redirect
          to.name !== 'login' && to.name !== 'password-reset' &&
          // make sure the user is authenticated
          !authenticated
      ) {
          // redirect the user to the login page
          return '/login';
      }

      if(
        to.name === 'login' && 
        authenticated
      ) {
        return '/';
      }

      document.title = to.meta.title + ' | GTM Performance Board'

      return true;
    })